import { useAuthContext } from "@contexts/AuthContext";
import { useStorageContext } from "@contexts/StorageContext";
import { Navigate, Outlet, useLocation } from "react-router";

import { PageLoadingOverlay } from "@components/common/ContentLoader";
import type { FC, JSX, PropsWithChildren } from "react";

/**
 * Protect a route to authenticated users only.
 * Authorization is enforced server-side via OpenFGA — the frontend
 * only gates on authentication, not roles.
 */
export const ProtectedRoute: FC = (): JSX.Element | null => {
  const { isAuthenticated, initialized } = useAuthContext();
  const { session } = useStorageContext();
  const { pathname } = useLocation();
  const redir = "redir";

  if (!initialized) {
    return <PageLoadingOverlay visible type="logo" size={240} />;
  }

  if (isAuthenticated()) {
    const route = session.get(redir);
    session.del(redir);
    return route ? <Navigate to={route} /> : <Outlet />;
  }
  session.set(redir, pathname);
  return <Navigate to="/login" />;
};
